import { ClientUserForm, ClientUserUpsert, ClientUser } from '@core/models'

export function transformToData(clientUser: ClientUser): ClientUser {
    return { ...clientUser };
}

export function transformToForm(clientUser: ClientUser): ClientUserForm {
    return {} as ClientUserForm;
}

export function transformToUpsert(authenticationForm: ClientUserForm): ClientUserUpsert {
    return {
        ...authenticationForm,
        nombre: authenticationForm.nombre,
        apellido: authenticationForm.apellido,
        direccion: authenticationForm.direccion,
        telefono: authenticationForm.telefono,
        correo: authenticationForm.correo,
        tienda_id: authenticationForm.tienda_id,
        estado_id: authenticationForm.estado_id,
        cuenta_id: authenticationForm.cuenta_id
    }
}
